import actions from './actions'

const initialState = {
  investorName: ""
}

export default function ioverificationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
